module.exports = __webpack_public_path__ + "img/landing3.73eb2f10.svg";